import { ISuggestedOrgInvite, ISuggestedOrgInviteConnection } from "@schema";

export function getSuggestedInvitesMap(suggestedInvites: ISuggestedOrgInviteConnection) {
  const suggestedInviteMap: { [calId: string]: ISuggestedOrgInvite } = {};
  if (!suggestedInvites || !suggestedInvites.edges) {
    return suggestedInviteMap;
  }

  suggestedInvites.edges.forEach((edge) => {
    if (edge?.node) {
      suggestedInviteMap[edge.node.targetCalendarId] = edge.node;
    }
  });

  return suggestedInviteMap;
}
